






































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyForm from "@/mixins/form";

import MyConfig from "@/config";

import TsUpload from "@/components/upload.vue";

import BpSubmitDialog from "./bp-submit-dialog.vue";

@Component({
  components: {
    TsUpload,
    BpSubmitDialog
  }
})
export default class extends Mixins(MyForm) {
  @Prop() editData!: any;

  @Prop() stadiumId!: number;

  apiserver: string = MyConfig.casapi;

  headers: any = {
    Authorization: window.localStorage.getItem("token")
  };

  fileList: any[] = [];

  previewVisible = false;

  previewImage = "";

  imageUrl = "";

  value = "";

  loading = false;

  submitting = false;

  geo_location = "";

  select_bp_submit_id = "";

  userInfo: { [t: string]: any } = {};

  submitDialogVisible: boolean = false;

  showSubmitDialog() {
    this.submitDialogVisible = true;
  }

  hideSubmitDialog() {
    this.submitDialogVisible = false;
  }

  fields: any[] = [];
  hasData: boolean = false;

  async loadFields() {
    const res = await this.$store.dispatch("bp/fields", {});
    // console.log(res);
    if (res && res.Data) {
      this.fields = res.Data;
    }
  }

  async loadSubmitData() {
    const res = await this.$store.dispatch("bp/wjSubmitDetail", {
      stadium_id: this.stadiumId
    });

    // console.log(res);
    if (res && res.Data) {
      this.hasData = true;
      this.form.setFieldsValue({ bp_submit: "1" });
      this.form.setFieldsValue({ bp_submit_id: res.Data.id });
      this.select_bp_submit_id = res.Data.id;
      this.formData = res.Data;
    } else {
    }
  }

  async selectBpSubmit(obj: any) {
    if (obj) {
      this.form.setFieldsValue({ bp_submit_id: obj.id });
      this.select_bp_submit_id = obj.id;

      this.hideSubmitDialog();
    }
  }

  normFile(e: any) {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }

  handleCancel1() {
    this.previewVisible = false;
  }

  handleChange(info: any) {
    if (info.file.status === "uploading") {
      this.loading = true;
      return;
    }
    if (info.file.status === "done") {
      // console.log(info)
      this.imageUrl = this.renderImage(info.file.response.Data);
      this.loading = false;
    }
  }

  handleChange1({ fileList }: any) {
    // this.fileList = fileList
  }

  handlePreview(file: any) {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  }

  handleRemove() {
    return new Promise(resolve => {
      this.$confirm({
        title: "确认信息",
        content: "你确定要删除吗？",
        onOk: async () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        }
      });
    });
  }

  changeNature(e: any) {
    // console.log(e);
    if (e.target.checked) {
      this.form.setFieldsValue({
        note: "非目标场馆"
      });
    } else {
      this.form.setFieldsValue({
        note: ""
      });
    }
  }

  async mounted() {
    // console.log(this.editData);
    this.userInfo = this.$store.state.user.userInfo;

    this.geolocation();

    await this.loadSubmitData();
  }

  geolocation() {
    window.AMap.plugin("AMap.Geolocation", () => {
      var geolocation = new window.AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        // 设置定位超时时间，默认：无穷大
        timeout: 10000,
        // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
        buttonOffset: new window.AMap.Pixel(10, 20),
        //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        zoomToAccuracy: true,
        //  定位按钮的排放位置,  RB表示右下
        buttonPosition: "RB"
      });

      geolocation.getCurrentPosition((status: string, result: any) => {
        if (status == "complete") {
          onComplete(result);
        } else {
          onError(result);
        }
      });

      const onComplete = (data: any) => {
        // data是具体的定位信息
        // console.log(data);
        if (data.addressComponent) {
          this.form.setFieldsValue({
            geo_location: `${data.addressComponent.city}${data.addressComponent.district}`
          });
        }
      };

      const onError = (data: any) => {
        // 定位出错
      };
    });
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            // if (!this.value) {
            //   this.$message.error('请输入备注内容')
            //   return
            // }

            // console.log(values);
            const values: any = {};

            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const val: any = _.get(fieldValues, [key]);

                if (val) {
                  if (key === "picurl") {
                    let picurl = "";
                    // const arr: any[] = val.fileList
                    for (const obj of val) {
                      picurl += `${obj.response.Data},`;
                    }

                    _.set(values, ["picurl"], _.trim(picurl, ","));
                  } else {
                    _.set(values, [key], val);
                  }
                }
              }
            }

            this.submitting = true;

            const res = await this.$store.dispatch("stadium/addnote", {
              //   note: this.value,
              stadium_id: this.stadiumId,
              admin_id: this.userInfo.id,
              admin_username: this.userInfo.name,
              nature: values.nature ? "-1" : "0",
              note: values.note,
              note_time: values.note_time.format("YYYY-MM-DD HH:mm:ss"),
              picurl: values.picurl,
              to: values.to,
              way: values.way,
              geo_location: values.geo_location,
              length_of_time: values.length_of_time,
              bp_submit: values.bp_submit,
              bp_submit_id: values.bp_submit_id
            });

            if (res && res.Message === "success") {
              //   this.loadData();
              this.value = "";
              //   this.form.setFieldsValue({
              //     nature: false,
              //     note: '',
              //     note_time: moment().format('YYYY-MM-DD HH:mm:ss'),
              //     picurl: '',
              //   });

              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.submitting = false;
          }
        });
      }
    });
  }

  handleNoteChange(e: any) {
    this.value = e.target.value;
  }
}
